import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Tooltip,
} from '@mui/material';
import PatientPicker from './Patient/PatientPicker';
import { Patient } from '../types/types';
import APIService from '../services/APIService';
import { useSubjectLanguage } from '@features/user';
import { Info, InfoOutlined } from '@mui/icons-material';
import AssignPatientToNoteDialog from './Patient/AssignPatientToNoteDialog';
import { capitalize } from '@utils/utils';
import { useEventTracking } from '@services/statsig';

interface AssignNoteToPatientProps {
  noteId: string;
  encounterId?: string;
  onAssign: (patient: Patient) => void;
  onAssignError?: () => void;
}

const AssignNoteToPatient: React.FC<AssignNoteToPatientProps> = ({
  noteId,
  encounterId,
  onAssign,
  onAssignError,
}) => {
  const subjectLanguage = useSubjectLanguage();
  const [open, setOpen] = useState(false);
  const { note } = useEventTracking();

  const handleOpen = () => {
    note.patientAssignmentClicked(noteId, {
      encounter_id: encounterId,
    });
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography
          variant="body1"
          onClick={handleOpen}
          sx={{
            textDecoration: 'underline',
            cursor: 'pointer',
            color: 'primary.main',
            marginRight: 1,
          }}
        >
          Assign Note to {capitalize(subjectLanguage)}
        </Typography>
        <Tooltip
          title={`Assign this note to a ${subjectLanguage} so JotPsych can pull forward information from this encounter next time you see this ${subjectLanguage}.`}
        >
          <InfoOutlined sx={{ color: 'grey.500', fontSize: '1.2rem' }} />
        </Tooltip>
      </Box>
      <AssignPatientToNoteDialog
        open={open}
        onClose={handleClose}
        noteId={noteId}
        encounterId={encounterId}
        onAssign={onAssign}
        onAssignError={onAssignError}
      />
    </>
  );
};

export default AssignNoteToPatient;
